module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Sport Aluminum + Walnut Open.b0994fee.png";